import React from 'react';
import { IonPage, IonContent} from '@ionic/react';
import MemberShipCard from "../components/MemberShipCard";

export default function MembershipMobilePage({ withoutLogin ,renderHeaderPage}) {

    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent
                fullscreen
                scrollEvents={true}
                className="membership-content page-content"
            >
                <div className="mobile-contain-membership">
                    <MemberShipCard withoutLogin={withoutLogin} isMobile={true} />
                </div>
            </IonContent>
        </IonPage>
    );
}
